import Flex from 'legacyfrontend/components/Flex';
import SlickImageGallery from 'legacyfrontend/components/slick-image-gallery';

const ImageGallery = ({ title, items, label }) => {
  if (!items.length === 0) return;
  return (
    <Flex className='card-box package-information__gallery' vertical>
      <Flex className='package-information__gallery__header' vertical>
        {label ? <p className='package-information__hotel-subtitle'>{label}</p> : ''}
        <h3 className='text-lg package-information__hotel-title'>{title.toLowerCase()}</h3>
      </Flex>
      <SlickImageGallery items={items} />
    </Flex>
  );
};

export default ImageGallery;
